/* NOTE:
This file shouldn't be touched since it's auto-generated.
If you aim at modifying it, you should instead do the following:
- edit templates/routes.handlebars
- run "node manage.js pages"
*/
import React, { lazy } from "react";
import { Route, Switch } from "react-router";
import { withLayout, withLoader } from "./components";

const USCS = lazy(() => import("./pages/"));
const PermissionDenied = lazy(() => import("./pages/403"));
const NotFound = lazy(() => import("./pages/404"));

const Routes = () => {
  return (
    <Switch>
      <Route
        exact
        path={"/"}
        component={withLoader(withLayout(USCS))}
      />
      <Route
        exact
        path="/403"
        component={withLoader(withLayout(PermissionDenied))}
      />
      <Route
        exact
        path="*"
        component={withLoader(withLayout(NotFound))}
      />
    </Switch>
  );
};

export default Routes;
